<template>
  <button
    :class="getVariant('button')"
    :type="type"
    class="button"
  >
    <div>
      <slot />
    </div>
  </button>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'ButtonView',

  mixins: [variant],

  props: {
    type: {
      type: String,
      default: 'button'
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/button/button-view.scss"></style>



// WEBPACK FOOTER //
// button-view.vue